import T from '@wojtekmaj/react-t';

import { ContentWrapper, Image, PageWrapper, Sub, Title } from './index.styles';

import VendorLogo from '../../common/vendor_logo';

import wifiIcon from '../../../static/wifi.svg';

export default function OfflinePage() {
  return (
    <PageWrapper>
      <ContentWrapper>
        <VendorLogo />
        <Image alt="" height={123} src={wifiIcon} width={123} />
        <Title>
          <T>You’re offline</T>
        </Title>
        <Sub>
          <T>Check if you paid the internet bill and try again.</T>
        </Sub>
      </ContentWrapper>
    </PageWrapper>
  );
}
